// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CredentialVerificationStatusSchema = z.enum(['PENDING','VERIFYING','VERIFIED','FAILED'] as const);

export type CredentialVerificationStatusType = `${z.infer<typeof CredentialVerificationStatusSchema>}`

export default CredentialVerificationStatusSchema;
